// @flow
import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';

export default styled<any, Theme>('a')`
  margin-left: 1.25em;
  width: 100%;
  display: block;
  white-space: nowrap;
  ${props => !props.selected && css`margin-left: 2.125em;`}
`;
